import { types, flow } from 'mobx-state-tree';
import Pass from './Pass';
import API from '../../api/passesFriendship';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';

const PassesStore = types
    .model('PassesStore', {
        passes: types.optional(types.array(Pass), []),
        selectedPass: types.maybe(types.reference(Pass)),
        totalPages: types.optional(types.number, 0),
        selectedPage: types.optional(types.number, 1),
        searchQuery: types.optional(types.string, ''),
        error: types.union(
            types.optional(types.string, ''),
            types.optional(types.array(types.string), []),
        ),
        dataLoaded: types.optional(types.boolean, false),
    })
    .views((self) => ({
        getNumOfPassAccesses(id) {
            let pass = self.passes.find((pass) => pass.id === id);
            return pass.accesses.length;
        },
        getNumOfPassAccessCodes(id) {
            let pass = self.passes.find((pass) => pass.id === id);
            return pass.access_codes?.length;
        },
    }))
    .actions((self) => ({
        getPasses: flow(function* getPasses(searchQuery, game_id = undefined, selectedSeason) {
            self.error = '';
            self.dataLoaded = false;
            try {
                const res = yield API.getPasses({
                    params: {
                        search: searchQuery ? searchQuery : undefined,
                        season_id: selectedSeason ? selectedSeason : 4,
                        limit: 10,
                        page: self.selectedPage,
                        game_id: game_id ? game_id : undefined,
                    },
                });
                if (res.data.items.length > 0) {
                    self.passes = res.data.items;
                } else {
                    self.passes = [];
                }
                self.totalPages = res.data.total_pages_count;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        setSelectedPage(page) {
            self.selectedPage = page;
        },
        setSearchQuery(query) {
            self.searchQuery = query;
        },
        selectPass(id) {
            self.selectedPass = id;
        },
        getPass: flow(function* getPass(id) {
            self.error = '';
            try {
                const res = yield API.getPass(id);
                self.dataLoaded = true;
                self.passes = [];
                self.passes.push(res.data);
                self.selectedPass = res.data.id;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        editPass: flow(function* editPass(edited) {
            try {
                // The type field is read-only and shows the API's display label,
                // which for a Fründe ticket is an empty string. Sent back, it
                // overwrote the real type and the ticket dropped out of the stock.
                const { type, ...editedPass } = edited;
                const res = yield API.editPass(self.selectedPass.id, {
                    ...editedPass,
                    user_id: editedPass.user_id === '' ? null : editedPass.user_id,
                    season_id: self.selectedPass.season_id,
                });
                self.selectedPass.editPass(res.data);
            } catch (error) {
                throw error;
            }
        }),
        addPass: flow(function* addPass(pass) {
            try {
                const res = yield API.createPass(pass);
                self.passes.push(res.data);
            } catch (error) {
                throw error;
            }
        }),
        deletePass: flow(function* deletePass(id) {
            try {
                yield API.deletePass(id);
                const index = self.passes.findIndex((s) => s.id === id);
                self.passes[index].deleted_at = 'deleted'; /// this is just a flag so front show pass as deleted. After refreshing page, it will take original value and stay 'flagged as deleted'
            } catch (error) {
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        revivePass: flow(function* revivePass(id) {
            try {
                yield API.revivePass(id);
                const index = self.passes.findIndex((s) => s.id === id);
                self.passes[index].deleted_at = null;
            } catch (error) {
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),

        setDataLoaded() {
            self.dataLoaded = true;
        },
    }));

export default PassesStore;
